module.exports = __webpack_public_path__ + "img/icon_hslx.70836621.png";